import { Navigate, Route, Routes } from 'react-router-dom'

import { links, paths } from 'apps'
import { CommonLayout } from 'layouts'
import { PrivateRoute } from 'routes'
import { EventMail, MailBoxMain, RaceMail, SystemMail } from './pages'
import { useAppSelector } from 'hooks'

function MailBox() {
  const auth = useAppSelector(state => state.auth)
  return (
    <Routes>
      <Route
        path={paths.default()}
        element={
          <PrivateRoute isLogged={auth.isLogged} layout={CommonLayout} navigate={links.home.index()}>
            <MailBoxMain />
          </PrivateRoute>
        }
      >
        <Route path={paths.mailbox.raceMail()} element={<RaceMail />} />
        <Route path={paths.mailbox.eventMail()} element={<EventMail />} />
        <Route path={paths.mailbox.systemMail()} element={<SystemMail />} />
        <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
      </Route>
      <Route path='*' element={<Navigate replace to={paths.notFound.feature()} />} />
    </Routes>
  )
}

export default MailBox
